import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, []);
  const syncCreditNote = `syncCreditNote(input: ${dataModify})`;
  return gql`
  mutation {
    ${syncCreditNote} {
      id
    }
  }
`;
};
